import './../../node_modules/react-bootstrap-table/dist/react-bootstrap-table-all.min.css';

import * as CryptoJs from 'crypto-js';
import * as React from 'react';

import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';

import JerseyRestApiService from '../JerseyRestApiService';
import PublisherInsertForm from './PublisherInsertForm';
import Snackbar from 'material-ui/Snackbar';

interface State {
    page: number;
    processedTable: any[];
    cellEditProp: any;
    option: any;
    selectRow: any;
    openSnackBar:any;
    snackBarMessage:any;
}

class Publishers extends React.Component<{}, State> {
    constructor() {
        super();

        const cellEditProp = {
            mode: 'dbclick',
            blurToSave: true,
            beforeSaveCell: this.onBeforeSaveCell.bind(this),
        };

        const option = {
            onDeleteRow: this.onDeleteRow,
            onAddRow: this.handleInsertedRow,
            insertModal: this.createCustomModal,

        };

        const selectRow = {
            mode: 'checkbox',
            bgColor: 'pink',
            className: 'my-selection-custom',
            columnWidth: '50px',
        };

        this.state = {
            page: 1,
            processedTable: [],
            cellEditProp: cellEditProp,
            option: option,
            selectRow: selectRow,
            openSnackBar: false,
            snackBarMessage:'',
        };

    }
    componentWillMount() {
        this.getPublishers();
    }

    getPublishers = () => {
        JerseyRestApiService.getAllActivePublishers((publisherTable: any[]) => {
            this.parseData(publisherTable);
        });
    }

    parseData = (tableData) => {
        let pubList=[];
        for(let pub in tableData){
            pubList[pub]=JSON.parse(JSON.stringify(tableData[pub]));
            if (pubList[pub]['propositions'] && pubList[pub]['propositions'][0]&&pubList[pub]['propositions'][0]['ctaUrl']){
                pubList[pub]['url']=pubList[pub]['propositions'][0]['ctaUrl'];
                pubList[pub]['packageName']='';
                pubList[pub]['propositionType']='CTA_URL';
            }
            else if (pubList[pub]['propositions'] && pubList[pub]['propositions'][0]&&pubList[pub]['propositions'][0]['appInstallMeta']){
                pubList[pub]['packageName']=pubList[pub]['propositions'][0]['appInstallMeta']['packageName'];
                pubList[pub]['url']=pubList[pub]['propositions'][0]['appInstallMeta']['appBundleUrl'];
                pubList[pub]['propositionType']='APP_INSTALL';
            }
            else{
                pubList[pub]['displayProposition']='';
                pubList[pub]['propositionType']='NO_PROPOSITIONS';
                pubList[pub]['url']='';
                pubList[pub]['packageName']='';
            }
                pubList[pub]['updated']=false;
        }

        this.setState({
            ...this.state,
            processedTable: pubList,
        });

    }

    onDeleteRow = (row, fullrow) => {
        row.forEach(function(value, index, array) {
            JerseyRestApiService.removePublisher(value);
        });
    }

    toJsonObject = (row) => {
        row['id']=CryptoJs.MD5(JSON.stringify(row)).toString().slice(0,10);
        row['active'] = true;
        switch (row['propositionType']) {
            case 'CTA_URL':
                row['propositions'] = [
                    {
                        appInstallMeta: null,
                        ctaUrl: row['url'],
                        type: 'CTA_URL',
                    },
                ];
                break;
            case 'APP_INSTALL':
                row['propositions'] = [
                    {
                        appInstallMeta: {
                            packageName: row['packageName'],
                            appBundleUrl: row['url'],
                        },
                        ctaUrl: null,
                        type: 'APP_INSTALL',
                    },
                ];
                break;

            default:
                row['propositions'] = [];
                break;
        }
        return row;
    }

    toJsonObjectForUpdate(row) {
        switch (row['propositionType']) {
            case 'CTA_URL':
                if (row['url'] == ''){
                    return null;
                }
                row['propositions'] = [
                    {
                        appInstallMeta: null,
                        ctaUrl: row['url'],
                        type: 'CTA_URL',
                    },
                ];
                break;
            case 'APP_INSTALL':
                if (row['url'] == '' || row['packageName'] == ''){
                    return null;
                }
                row['propositions'] = [
                    {
                        appInstallMeta: {
                            packageName: row['packageName'],
                            appBundleUrl: row['url'],
                        },
                        ctaUrl: null,
                        type: 'APP_INSTALL',
                    },
                ];
                break;

            default:
                row['propositions'] = [];
                break;
        }
        return row;
    }


    handleInsertedRow = (row) => {
        JerseyRestApiService.addPublisher(
            JSON.stringify(this.toJsonObject(row)),
            (response: any) => {
                this.getPublishers();
            },
        );
    }

    onBeforeSaveCell = (row, cellName, cellValue) =>{
        let updatedObject = this.state.processedTable.find(function(object) {
            return object['id'] == row['id'];
        });
        updatedObject[cellName] = cellValue;
        updatedObject['updated'] = true;
        this.setState({
            ...this.state,
        });
        return false;
    }

    handleClose = () => {
        this.setState({
            ...this.state,
            openSnackBar: false,
        });
    }


    validation = (cellName,cellValue) => {
        if (cellName == 'displayName'){
            let regexp = new RegExp('^[a-z0-9A-Z_\\s]+$');
            if (!regexp.test(cellValue)){
            this.setState({
                ...this.state,
                openSnackBar: true,
                snackBarMessage :'Please Provide correct DisplayName',
            });
            }
            return regexp.test(cellValue);
        }else if (cellName == 'propositionType') {
            let propositionsTypes = ['CTA_URL','APP_INSTALL','NO_PROPOSITION'];
            if (!propositionsTypes.includes(cellValue)){
               this.setState({
                ...this.state,
                openSnackBar: true,
                snackBarMessage :'Please Provide correct Proposition Type',
            });
            }
            return propositionsTypes.includes(cellValue);
        }else if (cellName == 'packageName') {
            let regexp = new RegExp('^((\\w+)(\\.))+(\\w+)$');
            if (!regexp.test(cellValue)){
                this.setState({
                ...this.state,
                openSnackBar: true,
                snackBarMessage :'Please Provide correct Package Name',
            });
            }
            return regexp.test(cellValue);
        }else if (cellName == 'url') {
            let regexp = new RegExp('^http(s)?://([\\w-]+\\.)+[\\w-]+(/[\\w- ./?%&amp;=]*)?$');
            if (!regexp.test(cellValue)){
                this.setState({
                ...this.state,
                openSnackBar: true,
                snackBarMessage :'Please Provide correct URL',
            });
            }
            return regexp.test(cellValue);
        }
    }

    updateRow(row) {
        if (this.toJsonObjectForUpdate(row)) {
            JerseyRestApiService.updatePublisher(
                JSON.stringify(this.toJsonObjectForUpdate(row)),
                (response: any) => {
                    let updatedObject = this.state.processedTable.find(function(
                        object,
                    ) {
                        return object['id'] == row['id'];
                    });
                    updatedObject['updated'] = false;
                    this.getPublishers();
                },
            );
        } else {
                    this.getPublishers();
        }
    }

    cellButton = (cell, row, enumObject, rowIndex) =>{
        if (row['updated']) {
            return (
                <button
                    style={{ backgroundColor: 'orangered', color: 'white' }}
                    type='button'
                    onClick={() => this.updateRow(row)}
                >
                    update
                </button>
            );
        } else {
        }
    }


    createCustomModal = (onModalClose, onSave, columns, validateState, ignoreEditable) => {

        return (
            <PublisherInsertForm
                onModalClose = {onModalClose}
                onSave= {onSave}
                columns = {columns}
                validateState = {validateState}
                ignoreEditable= {ignoreEditable}
            />
        );
    }


    render() {
        return (
            <div style={{ marginTop: '80px', width: '100%' }}>
                <BootstrapTable ref='table' data={this.state.processedTable} cellEdit={ this.state.cellEditProp } selectRow={ this.state.selectRow } insertRow={ true } options={this.state.option} deleteRow hover search >
                    <TableHeaderColumn isKey={true} dataField='id' width='8%' hidden >ID</TableHeaderColumn>
                    <TableHeaderColumn dataField='name' width='8%' hidden >Name</TableHeaderColumn>
                    <TableHeaderColumn dataField='displayName' width='8%' >DisplayName</TableHeaderColumn>
                    <TableHeaderColumn dataField='active' width='5%' hidden editable={{type: 'select', options: { values: [{value:true,text:'true'},{value:false,text:'false'}] } }}>Active</TableHeaderColumn>
                    <TableHeaderColumn dataField='propositionType' width='10%' editable={{type: 'select', options: { values: [{value:'CTA_URL','text':'CTA_URL'},{value:'APP_INSTALL',text:'APP_INSTALL'},{value:'NO_PROPOSITION',text:'No Proposition'}] } }}>PropositionType</TableHeaderColumn>
                    <TableHeaderColumn dataField='url' width='25%'>URL(APP BUNDLE/CTA) </TableHeaderColumn>
                    <TableHeaderColumn dataField="logoUrl" width="25%">Publisher Logo URL </TableHeaderColumn>
                    <TableHeaderColumn dataField='packageName' width='10%' >PackageName</TableHeaderColumn>
                    <TableHeaderColumn required dataField='primaryReserveCount' hidden width='10%' >primaryReserveCount</TableHeaderColumn>
                    <TableHeaderColumn dataField='primaryReserveExpiryInDays' hidden width='10%' >PrimaryReserveExpiryInDays</TableHeaderColumn>
                    <TableHeaderColumn dataField='secondaryReserveCount' hidden width='10%' >SecondaryReserveCount</TableHeaderColumn>
                    <TableHeaderColumn dataField='secondaryReserveExpiryInDays' hidden width='10%' >SecondaryReserveExpiryInDays</TableHeaderColumn>
                    <TableHeaderColumn dataField='button' width='6%' autoValue={true} editable={false} dataFormat={this.cellButton}>Update</TableHeaderColumn>

                </BootstrapTable>
            <Snackbar open={this.state.openSnackBar} message={this.state.snackBarMessage} onRequestClose={this.handleClose} autoHideDuration={2000} />

            </div>
        );
    }
}

export default Publishers;



// WEBPACK FOOTER //
// ./src/components/Publishers.tsx